export default __webpack_public_path__ + "static/media/dentalIcon.1921ef8e.svg";